import { IRecipeComponentBag } from '@/widgets/recipe/types';
import styles from './index.module.sass';
import { toReadable } from '@/modules/mixing/helpers/to-readable.helper';

export const SleevesList = ({ data }: { data?: IRecipeComponentBag[] }) => {
  return (
    <div className={styles.root}>
      <ul className={styles.scrollable}>
        { data?.map((bag) => <li>
          1. <span className={styles.sleeveId}>{bag.id}</span>
          <span className={styles.weight}>
            {toReadable(bag.weight)} <span className={styles.postfix}>т</span>
          </span>
        </li>)}
      </ul>
    </div>
  );
};
